module.exports = __webpack_public_path__ + "media/images/top-design-05-f061c0671b4431f6eaea845c63533540.jpg";